var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{ref:"divRef",class:_vm.textOver && !_vm.btnFold ? 'inner over' : 'inner'},[_c('span',{ref:"spanRef",staticClass:"content"},[_vm._v("擅长："+_vm._s(_vm.showContent))])]),_vm._v(" "),(_vm.textOver)?_c('img',{attrs:{"src":_vm.bg_url},on:{"click":_vm.showtext}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cde31cfe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/foldText/foldText.vue
// module id = null
// module chunks = 